// extracted by mini-css-extract-plugin
module.exports = {"productPrice":"OnjFr","secondary":"cwk5i","crossed":"_3sDAb","basePrice":"_0o3Qi","priceBreakdown":"+j2N0"};